import script from "./AppLoading.vue?vue&type=script&setup=true&lang=js"
export * from "./AppLoading.vue?vue&type=script&setup=true&lang=js"

import "./AppLoading.vue?vue&type=style&index=0&id=504fd8cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-504fd8cc"]])

export default __exports__